import { ReactNode, useState } from 'react';
import { useSelector } from 'react-redux';
import { getBuildingById } from 'src/api/get-building.api';
import PageLoader from 'src/components/PageLoader';
import { GetBuildingSuccessResponse } from 'src/configs/APISchemas/GetBuilding';
import { useMount } from 'src/helpers/hooks/useMount';
import { getPurchasePolicyInput } from 'src/redux/selectors/purchasePolicy';

interface BuildingDataLoaderProps {
  children: ReactNode;
  onBuildingDataLoaded: (
    buildingData: GetBuildingSuccessResponse['building'] | null,
  ) => void;
}

export const BuildingDataLoader = ({
  children,
  onBuildingDataLoaded,
}: BuildingDataLoaderProps) => {
  const [loadingStatus, setLoadingStatus] = useState<'pending' | 'resolved'>(
    'pending',
  );

  const purchasePolicyInput = useSelector(getPurchasePolicyInput);

  useMount(() => {
    const buildingId = purchasePolicyInput.buildingId;

    if (!buildingId) {
      setLoadingStatus('resolved');
      return;
    }

    getBuildingById(buildingId)
      .then((buildingData) => {
        const usedBuildingData = buildingData ?? null;
        onBuildingDataLoaded(usedBuildingData);
      })
      .finally(() => {
        setLoadingStatus('resolved');
      });
  });

  if (loadingStatus === 'pending') {
    return <PageLoader />;
  }

  return <>{children}</>;
};
